const protocoleConstants = {
  CREATE_PROTOCOLE_REQUEST: 'PROTOCOLES_CREATE_PROTOCOLE_REQUEST',
  CREATE_PROTOCOLE_SUCCESS: 'PROTOCOLES_CREATE_PROTOCOLE_SUCCESS',
  CREATE_PROTOCOLE_FAILURE: 'PROTOCOLES_CREATE_PROTOCOLE_FAILURE',
};

export default protocoleConstants;
